export interface SliderBounds {
  min: number
  max: number
  step: number
}

export function parseSliderBounds(
  minValue: number,
  maxValue: number,
  step: number,
): SliderBounds | null {
  if (
    !Number.isFinite(minValue) ||
    !Number.isFinite(maxValue) ||
    !Number.isFinite(step)
  ) {
    return null
  }
  if (
    !Number.isInteger(minValue) ||
    !Number.isInteger(maxValue) ||
    !Number.isInteger(step)
  ) {
    return null
  }
  if (step < 1 || minValue >= maxValue || (maxValue - minValue) % step !== 0) {
    return null
  }
  return { min: minValue, max: maxValue, step }
}

/** Figma 5074-13561 — "{value} — {label}" when label is set. */
export function formatSliderEndLabel(value: number, label: string): string {
  const text = label.trim()
  return text.length > 0 ? `${value} — ${text}` : String(value)
}
